// extracted by mini-css-extract-plugin
module.exports = {"classView":"ClassView_classView__3hjnX","classContent":"ClassView_classContent__xWBh2","leftPannel":"ClassView_leftPannel__2mZQy","videoContent":"ClassView_videoContent__1He8E"};